import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { RedirectService } from 'src/app/core/services/redirect/redirect.service';
import { UsuarioService } from 'src/app/core/services/usuario/usuario.service';
declare var $: any;

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthService, private usuarioService: UsuarioService, private redirect: RedirectService) {


  }

  ngOnInit(): void {
    $('#spinner-load').css("display", "none");
    if (this.usuarioService.isLoggedIn()) {
      this.authService.logout();
      window.location.reload();
      console.log('logout')
    } else {
      this.redirect.toLogin();
      console.log('login')

    }
  }

}
